module.exports = __webpack_public_path__ + "welcome3-50424f5d291f536c90fffbfd0b1da1eb.png";